import useSWR from 'swr'

import { IOrganization } from '../types'
import createRestClient from './createRestClient'
import useWorkspaceId from './useWorkspaceId'

export default function useOrganization() {
  const workspaceId = useWorkspaceId()

  const { data, error } = useSWR('organization', async () => {
    const organization = await createRestClient(workspaceId).get<IOrganization>('organization')

    if (organization) {
      sessionStorage.setItem('workspaceName', organization.workspaceName)
    }

    return organization
  })

  if (error) {
    throw error
  }

  return data
}
